module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"field":{"used_by_other_places":"他の施設で利用中のセンサー","count":"{count}件"}},"en":{"field":{"used_by_other_places":"Sensors used by other facilities","count":"{count}"}}}')
  delete Component.options._Ctor
}
